export default __webpack_public_path__ + "static/media/invoicing.a7292c57.svg";